import { Component } from '@angular/core';

@Component({
  selector: 'laps-invoice-not-sent-template',
  templateUrl: './invoice-not-sent-template.component.html',
})
export class InvoiceNotSentTemplateComponent {}
